import { render, staticRenderFns } from "./group_index.vue?vue&type=template&id=a50a7554&"
import script from "./group_index.vue?vue&type=script&lang=js&"
export * from "./group_index.vue?vue&type=script&lang=js&"
import style0 from "./group_index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports